// ContentArea Component
// LazySEM Frontend - Main content area with breadcrumbs and grid system

import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumbs } from "../Breadcrumbs/Breadcrumbs";
import { useNavigation } from "../../hooks/useNavigation";
import styles from "./ContentArea.module.css";

interface ContentAreaProps {
  children: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
  className?: string;
}

export const ContentArea: React.FC<ContentAreaProps> = ({
  children,
  title,
  actions,
  className = "",
}) => {
  const { breadcrumbs, activeItem } = useNavigation();
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  const nested = segments.length > 1;
  const parentPath = `/${segments[0]}`;

  return (
    <main className={`${styles.contentArea} ${className}`}>
      {/* Breadcrumbs */}
      {nested && breadcrumbs.length > 1 && (
        <div className={styles.breadcrumbsContainer}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <Link className={styles.parentLink} to={parentPath}>
            ← Back to {activeItem?.label || segments[0]}
          </Link>
        </div>
      )}

      {/* Page Header */}
      {(title || actions) && (
        <div className={styles.pageHeader}>
          {title && <h1 className={styles.pageTitle}>{title}</h1>}
          {actions && <div className={styles.pageActions}>{actions}</div>}
        </div>
      )}

      {/* Content */}
      <div className={styles.content}>{children}</div>
    </main>
  );
};

export default ContentArea;
